import { Button } from "design-system/atoms/Button"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "design-system/atoms/Dialog"
import { useTranslation } from "react-i18next"

type OptInDialogProps = {
  open: boolean
  onClose: () => void
  onConfirm: () => void
  isPending?: boolean
}

export function OptInDialog({ open, onClose, onConfirm, isPending }: OptInDialogProps) {
  const { t } = useTranslation()

  return (
    <Dialog
      open={open}
      onOpenChange={(isOpen) => {
        if (!isOpen) onClose()
      }}
    >
      <DialogContent>
        <DialogHeader className="flex flex-col gap-6">
          <DialogTitle>{t("customers.profile.optIn.title")}</DialogTitle>
          <DialogDescription>
            <p>{t("customers.profile.optIn.description")}</p>
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="pt-4 gap-2">
          <Button type="button" variant="outline" onClick={onClose} disabled={isPending}>
            {t("shared.cancel")}
          </Button>
          <Button type="button" onClick={onConfirm} disabled={isPending}>
            {t("customers.profile.optIn.confirm")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
